export const planSports = ['football', 'nba', 'nfl', 'mlb'] as const;
export type PlanSport = (typeof planSports)[number];
export const baseSportPriceCents = 6990;
export const extraSportPriceCents = 2990;
export const freeScans = 5;
export const monthlyScans = 100;
